import React from 'react';

function Info() {
  return (
    <div className='info'>
      <h2>Information</h2>
      <p>This project aims self improvement for individual seeking help to get diciplined.</p>
      <ul>
        <li>Every day new tasks will be displayed that user need to complete and all data is stored in local storage.</li>
        <li>Every task completed get a score of 10 so you can easily calculate how many task you completed with points%10 days completed is also a leve shown there.</li>
        <li>Complete tasks daily to improve yourself dont cheat yourself be better everyday.</li>
        <li>Data is stored in browser so if you open project on another browser it will consider it as new user.</li>
      </ul>
    </div>
  );
}

export default Info;